import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Header from '../../include/Header';
import Sidebar from '../../include/Sidebar';
import {addUserCategory} from '../../../../Store/User/Category/AddUserCategory';


const ManageCategory = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const data = location.state;
    // console.log(data, '@@')

    useEffect(() => {
        if (location.state) {
            setCategory(location.state?.name);
            setSelectValue(location.state?.status);
        }
    }, [location.state]);

    useEffect(() => {
        if (localStorage.getItem('PAY_ADMIN_TOKEN') === null) {
            navigate("/admin/login");
        }
    }, [navigate]);

    const [category, setCategory] = useState('');
    const [disable, setDisable] = useState(false);
    const [error, setError] = useState('');
    const [selectValue, setSelectValue] = useState('');


    const handleRadioChange = (event) => {
        setSelectValue(event.target.checked);
    };

    
    const handleSubmit = () => {
        if (validation()) {
            setDisable(true)
            const formData = new URLSearchParams();

            formData.append('name', category);
            if (data?._id) {
                formData.append('id', data?._id);
                formData.append('status', selectValue);
            }

            dispatch(addUserCategory(formData))
                .then((res) => {
                    // console.log(res, 'REs');

                    if (res.payload.success === true) {
                        navigate('/admin/category-management');
                        setCategory('');
                    }
                    setDisable(false)
                }).catch((error) => {
                    console.log(error, 'Error')
                    setDisable(false)
                })
        }
    }

    const validation = () => {
        var isValid = true;
        let err = {};

        if (!category || !category?.trim()) {
            isValid = false;
            err['category_err'] = "Please enter category"
        }

        setError(err);
        return isValid;

    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <>
            <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
                <Header handleOpen={handleOpen} />
                <Sidebar />
                <div className="page-wrapper">
                    <div className="content container-fluid">
                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title admin-title">{data?._id ? 'Edit' : 'Add'} Category</h3>
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/admin/dashboard">Dashboard</Link></li>
                                        <li className="breadcrumb-item"><Link to="/admin/category-management">Category Management</Link></li>
                                        <li className="breadcrumb-item active">{data?._id ? 'Edit' : 'Add'} Category</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="card p-3 basicform">
                           

                            <div className="row card_id d-flex justify-content-start align-center">
                                <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label htmlFor="Name" className="form-label">Name</label>
                                            <input type="text" className="form-control" id="Name"
                                                onChange={(e) => setCategory(e.target.value)} value={category}
                                            />
                                            <div className='error'>{error.category_err}</div>
                                        </div>
                                    </div>
                                </div>
                                {data?._id ? (
                                    <div className='col-md-4 col-lg-4 col-xxl-4 col-sm-12'>
                                        <div className="cardNum">
                                            <div className="mb-3">
                                                <label htmlFor="fileUpload" className="form-label">Status</label>
                                                <div className="form-check form-switch">
                                                    <input className="form-check-input" type="checkbox" role="switch" onChange={handleRadioChange} checked={selectValue} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                            </div>

                            <div className="row card_id mt-4 sm-mt-3">
                                <div className=" col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3 d-flex gap-2">
                                            <button className="btn btn-success w-50" type='button' onClick={handleSubmit} disabled={disable}>{disable ? "Processing..." : (data?._id ? 'Update' : 'Submit')}</button>
                                            <button className="btn btn-outline-secondary w-50" type='butotn' onClick={() => setCategory('')}>Reset</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </>
    )
}

export default ManageCategory